export const vars = {
  // Media queries
  mq: {
    xs: '0',
    sm: '576px',
    md: '768px',
    lg: '1025px',
    xl: '1900px',
  },
};

export default { vars };
